module.exports = __webpack_public_path__ + "images/sendee5a79f090ff1f6057718388b36ebfcd.svg";